// src/utils/apiClient.js

// ✅ Prefer env var, fallback to local
const BASE_URL = "https://5ae754hrre.execute-api.us-east-1.amazonaws.com/dev/";

// Ensure base ends with "/"
const base = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;

function buildUrl(path, params) {
	// Remove any leading "/" so URL doesn't reset to domain root
	const cleanPath = String(path || "").replace(/^\/+/, "");

	const url = new URL(cleanPath, base);

	if (params) {
		Object.entries(params).forEach(([k, v]) => {
			if (v === undefined || v === null || v === "") return;
			url.searchParams.set(k, String(v));
		});
	}

	return url.toString();
}

// ✅ helper: Bearer header
export const withAuth = (token) => ({
	Authorization: `Bearer ${token}`
});

async function request(
	method,
	path,
	{ params, body, signal, headers, onUnauthorized } = {}
) {
	const url = buildUrl(path, params);

	const isFormData =
		typeof FormData !== "undefined" && body instanceof FormData;

	const res = await fetch(url, {
		method,

		// ✅ no cookies now (token auth)
		credentials: "omit",

		headers: {
			...(isFormData ? {} : { "Content-Type": "application/json" }),
			...(headers || {})
		},

		body:
			body === undefined
				? undefined
				: isFormData
				? body
				: typeof body === "string"
				? body
				: JSON.stringify(body),

		signal
	});

	if (res.status === 401) {
		onUnauthorized?.();
		const err = new Error("Unauthorized");
		err.status = 401;
		throw err;
	}

	const text = await res.text();
	let data = null;
	try {
		data = text ? JSON.parse(text) : null;
	} catch {
		data = text || null;
	}

	if (!res.ok) {
		const msg =
			(data && (data.message || data.error)) ||
			`Request failed: ${res.status} ${res.statusText}`;
		const err = new Error(msg);
		err.status = res.status;
		err.data = data;
		throw err;
	}

	return data;
}

export const apiGet = (path, opts = {}) => request("GET", path, opts);
export const apiPost = (path, opts = {}) => request("POST", path, opts);
